export function getOnlineMeetingLink(
  reservation: { onlineMeetingUrl?: string | null; onlineMeetingProvider?: string | null; bodyHtml?: string } | null,
  document: Document
): { url: string; label: string } | null {
  if (!reservation) return null;

  const body = document.createElement('template');
  body.innerHTML = reservation.bodyHtml ?? '';
  const url = [
    reservation.onlineMeetingUrl,
    reservation.onlineMeetingProvider,
    ...Array.from(body.content.querySelectorAll('a[href]'), (anchor) => anchor.getAttribute('href')),
    ...(body.content.textContent?.match(/https:\/\/[^\s<>"']+/g) ?? []),
  ].find((value) =>
    /^https:\/\/(?:meet\.google\.com|teams\.(?:microsoft\.com|live\.com|cloud\.microsoft)|(?:[\w-]+\.)*webex\.com)\//i.test(
      value ?? ''
    )
  );
  const hostname = url ? new URL(url).hostname : '';
  return url
    ? {
        url,
        label: hostname.endsWith('webex.com')
          ? 'Webex'
          : hostname.startsWith('teams.')
            ? 'Microsoft Teams'
            : 'Hangouts Meet',
      }
    : null;
}
